import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isAddResourceGroupRequestFailure(namespace) {
      const req = getState().find((req) => req.namespace === namespace);

      return req ? req.requestState.isFailure : false;
    },
    isAddResourceGroupRequestPending(namespace) {
      const req = getState().find((req) => req.namespace === namespace);

      return req ? req.requestState.isPending : false;
    },
    isAddResourceGroupRequestSuccess(namespace) {
      const req = getState().find((req) => req.namespace === namespace);

      return req ? req.requestState.isSuccessful : false;
    },
  };
}

export { createSelector };
